function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.4 6.51c-1.214-.116-2.285.854-2.391 2.167-.082.997.423 1.811 1.196 2.332.471.318.742.642.809 1.259l1.126.106c.55.052 1.033-.386 1.08-.98l.196-2.406C7.468 7.72 6.583 6.621 5.4 6.51zM12.702 20.513l16.123-9.003c.31.605.195 1.339-.236 1.802-.09.097-6.011 5.35-6.011 5.35l-7.903 6.162a2.243 2.243 0 01-.34.292 2.085 2.085 0 01-1.136.384H10.56a.037.037 0 01-.006-.007c-.668-.045-1.305-.43-1.676-1.096l-3.626-6.092-.289-.462a.748.748 0 01-.024-.04l-.02-.031-.093-.149a3.157 3.157 0 01-.404-1.716c.07-1.447 1.083-2.599 2.361-2.8l1.867-.32 10.865-1.957c.095.526-.035 1.16-.7 1.492 0 0-5.751 2.003-9.068 3.19v.002l-1.518.52v.303l1.766.1.569 2.112 1.303 1.801.123.163h.712z",
  fill: "currentColor"
})));